export default {
  events: 'Arrangementer',
  loadingEvents: 'Henter arrangementer...',
  noUpcomingEvents: 'Ingen kommende arrangementer',
  updateEvents: 'Synkroniser arrangementer',
  facebookLink: 'Se arrangementet på Facebook',
};
